import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';

import { statComparisonNavSelector } from 'store/modules/statspro/stat-comparison/selectors';
import { UPDATE_NAV_ITEM } from 'store/modules/statspro/stat-comparison/actions';
import { STATS_CATEGORY_ARRAY } from '../../../common/config/categories';
import { getTranslation } from 'common/react/utils/translations';

export const CategoryNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(statComparisonNavSelector);

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={STATS_CATEGORY_ARRAY}
                className="w-100"
                initialSelectedItem={nav.category}
                isReadyToRender={() => true}
                itemToString={(item) => item}
                icon="player-stats"
                type="with-default"
                activeItem={nav.category}
                label={getTranslation('label.statsLeaders.nav.category')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        UPDATE_NAV_ITEM.request({
                            navItem: 'category',
                            value: selectedItem
                        })
                    );
                }}
                hideLabel
            />
        </div>
    );
};
